module.exports = __webpack_public_path__ + "static/media/arrow_left_black.65562471.svg";